import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import {
  ConfigurationContainer,
  ConfigurationHeader,
  ConfigurationNumericInput,
  ConfigurationSection,
  LabelContainer,
  TooltipIcon,
} from 'components/admin/channels/config_components';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { H3 } from 'components/common/headers';
import Toggle from 'components/common/toggle';
import Tooltip from 'components/lib/deprecated_tooltip';

export default function MailConfig({
  assignMailToConversationAssignee,
  endMailSessionIntervalMins,
  updateEditedConfigValue,
}) {
  const { t } = useTranslation();

  const assignMailTooltipMessage = assignMailToConversationAssignee
    ? t('Agent is automatically assigned')
    : t('New agent will be found');
  return (
    <div>
      <H3 data-aid="mailConfig-title">{t('Mail')}</H3>
      <ConfigurationSection data-aid="mailConfigSection">
        <ConfigurationContainer>
          <MailConfigurationHeader>
            <LabelContainer data-aid="assignMailToConversationAssigneeLabel">
              {t('Assign mails to same agent if conversation is open')}
            </LabelContainer>
            {renderConfigurationTooltip(assignMailTooltipMessage)}
          </MailConfigurationHeader>
          <Toggle
            data-aid="assignMailToggle"
            isEnabled={assignMailToConversationAssignee}
            onChange={toggleAssignMail}
          />
        </ConfigurationContainer>
        {assignMailToConversationAssignee ? null : (
          <ConfigurationContainer>
            <MailConfigurationHeader>
              <LabelContainer data-aid="endMailSessionIntervalMinsLabel">
                {t('Route to same agent after replying (in mins)')}
              </LabelContainer>
              {renderConfigurationTooltip(
                t('After replying to a mail, the number of mins during which the same agent is assigned automatically')
              )}
            </MailConfigurationHeader>
            <ConfigurationNumericInput
              data-aid="endMailSessionIntervalMinsInput"
              minValue={0}
              onChange={value => updateEditedConfigValue({ key: 'endMailSessionIntervalMins', value })}
              value={endMailSessionIntervalMins}
            />
          </ConfigurationContainer>
        )}
      </ConfigurationSection>
    </div>
  );

  function toggleAssignMail() {
    updateEditedConfigValue({ key: 'assignMailToConversationAssignee', value: !assignMailToConversationAssignee });
  }

  function renderConfigurationTooltip(message) {
    return (
      <Tooltip message={message} position="bottom">
        <div>
          <TooltipIcon icon={faInfoCircle} />
        </div>
      </Tooltip>
    );
  }
}

const MailConfigurationHeader = styled(ConfigurationHeader)`
  width: 340px;
`;

MailConfig.propTypes = {
  assignMailToConversationAssignee: PropTypes.bool,
  endMailSessionIntervalMins: PropTypes.number,
  updateEditedConfigValue: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/channels/mail_config.jsx